module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/people_icon-96e420fad177c5f83bd5ae9649ba7f76.svg";